import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=36ed89a2"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonDropdown: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button-dropdown/ButtonDropdown.vue').default,Address: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/address/Address.vue').default})
